import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import { defineComponent, toRefs, watch } from "@vue/composition-api";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { identificationValidator } from "@Client/@Composables/application-standalone/validations/identificationValidator";
import { identificationsPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/identifications/identificationsPageBindingsAndVisibilities";
import { get } from "lodash";
export default defineComponent({
  name: "IdentificationInformation",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    TextField,
    SelectField
  },
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    identificationIndex: {
      type: Number,
      required: true
    },
    applicantId: {
      type: String,
      required: true
    },
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const {
      applicantIndex,
      identificationIndex,
      applicantId,
      showErrors
    } = toRefs(props);
    const {
      applicantNameFromIndex
    } = useApplicantHelpers();
    const applicantName = applicantNameFromIndex(applicantIndex.value);
    const {
      bindings,
      visibilities
    } = identificationsPageBindingsAndVisibilities(applicantIndex, identificationIndex, applicantId);
    const {
      identificationType,
      identificationCountry,
      identificationNumber
    } = bindings;
    const {
      applicantIdentificationOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      identificationTypeVisible,
      identificationCountryVisible,
      identificationNumberVisible
    } = visibilities;
    const {
      v$
    } = identificationValidator(applicantIndex, identificationIndex);
    watch(showErrors, newVal => {
      if (newVal) {
        var _v$$value;
        v$ == null ? void 0 : (_v$$value = v$.value) == null ? void 0 : _v$$value.$touch();
      }
    });
    const getValidator = path => get(v$.value, path, null);
    return {
      applicantName,
      identificationType,
      identificationCountry,
      identificationNumber,
      applicantIdentificationOptions,
      identificationTypeVisible,
      identificationCountryVisible,
      identificationNumberVisible,
      v$,
      getValidator
    };
  }
});